import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { ResolverHelper } from "./resolver.helper";
import { SearchMode, SearchStateService } from "src/services/search-state.service";

export const CompanyCheckSearchResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const searchStateService = inject(SearchStateService);
    const router = inject(Router);
    const queryParams = route.queryParams;
    const hasOrgNumber = queryParams.hasOwnProperty("orgNumber");
    const hasCompanyName = queryParams.hasOwnProperty("companyName");

    let orgNumber: string = null;
    let companyName: string = null;
    if (hasOrgNumber) {
        orgNumber = queryParams["orgNumber"] != null ? queryParams["orgNumber"].toString() : null;
    }
    if (hasCompanyName) {
        companyName = queryParams["companyName"] != null ? queryParams["companyName"].toString() : null;
    }

    if (orgNumber || companyName) {
        return ResolverHelper.hasPermission(authService, EVServiceType.Internal_Debug).pipe(
            take(1),
            switchMap((hasDebugRole) => {
                return ResolverHelper.hasPermission(authService, [EVServiceType.EvWeb_CompanyCheck]).pipe(
                    take(1),
                    switchMap((hasCompanyCheckRole) => {
                        if (hasCompanyCheckRole) {
                            if (hasDebugRole) {
                                // The searchpage reads the company search from SearchStateService, not from the url
                                searchStateService.setCompanySearchOrganizationNumberString(orgNumber || null);
                                searchStateService.setCompanySearchOrganizationNameString(orgNumber ? null : companyName);
                                searchStateService.setCustomerSearchPersonIdentificationString(null);
                                searchStateService.setCustomerSearchPersonNameString(null);
                                searchStateService.setCustomerSearchPersonPostalCodeString(null);
                                searchStateService.setActiveSearchMode(SearchMode.CUSTOMERCHECK);
                                router.navigate(["/searchpage"], {
                                    queryParams: {
                                        searchMode: SearchMode.CUSTOMERCHECK,
                                    },
                                });
                                return EMPTY; // Allow navigation to proceed to the search page
                            } else {
                                const searchParam = orgNumber
                                    ? "companyorganizationnumber=" + encodeURIComponent(orgNumber)
                                    : "companyname=" + encodeURIComponent(companyName);
                                const url = environment.evwebUrl + "/searchpage?" + searchParam + "&dosearch=true&searchMode=3";
                                window.open(url, "_self");
                                return EMPTY;
                            }
                        } else {
                            return ResolverHelper.redirectToFrontPage(authService, router);
                        }
                    }),
                );
            }),
        );
    } else {
        return ResolverHelper.redirectToFrontPage(authService, router);
    }
};
